import type { TransactionEntity } from '@/api/types';
import { amountToCurrency, getCurrency } from '@/utils/format';

export type CsvColumns = {
  accountNames: Map<string, string>;
  categoryNames: Map<string, string>;
};

/** Same shape as loot-core's `transactions-export-query` CSV. */
export function transactionsToCsv(
  transactions: TransactionEntity[],
  columns: CsvColumns,
  currencyCode = 'USD',
): string {
  const currency = getCurrency(currencyCode);
  const header = [
    'Date',
    'Account',
    'Payee',
    'Category',
    'Notes',
    'Amount',
    'Cleared',
  ];
  const rows = transactions.map(txn => [
    txn.date,
    columns.accountNames.get(txn.account) ?? txn.account,
    txn.payee_name ?? '',
    (txn.category && columns.categoryNames.get(txn.category)) || '',
    txn.notes ?? '',
    amountToCurrency(txn.amount, currency),
    txn.cleared ? '1' : '0',
  ]);

  return [header, ...rows]
    .map(cells =>
      cells.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','),
    )
    .join('\r\n');
}

export function downloadCsv(filename: string, csv: string): void {
  const url = URL.createObjectURL(
    new Blob([csv], { type: 'text/csv;charset=utf-8' }),
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
